import axios from 'axios'

export default {
  getCategories(id) {
      return axios.get('/api/resolutioncodes/lookup/' + id);
  }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/resolutioncategoryselector/api.js